import React from 'react'
import PropTypes from 'prop-types'

const Close = ({ size = 20, onClick }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="#404E68"
            onClick={onClick}
            style={{ cursor: 'pointer' }}
        >
            <path
                d="M5 15L15 5M5 5L15 15"
                stroke="#404E68"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

Close.propTypes = {
    size: PropTypes.number,
    onClick: PropTypes.func,
}

export default Close
